// NaN indicates NEW
// Otherwise it's a number with precision restricted to avoid cross-platform issues.
export default function gradePercent(priority: number): number {
  if (Number.isNaN(priority)) {
    return Number.NaN;
  }
  const str = Math.max(0, 1 - priority).toPrecision(10);
  return Number.parseFloat(str);
}
